import React from 'react';

import {Button, ButtonComponentProps} from "./button";
import {Link} from "../../link/link";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";

export class LinkButtonProps extends ButtonComponentProps {
  linkModel: BaseLinkModel;
  replace: Boolean;
  enabled: Boolean;
  onClick: Function;
  onMouseEnter: Function;
  onMouseLeave: Function;
}

export const LinkButton = (props: LinkButtonProps) => {
  const onClick = props.onClick ? (params) => props.onClick(params) : () => true;

  const linkProps = {
    model: props.linkModel,
    replace: props.replace,
    onClick,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
  }

  const buttonProps = {
    ...props,
    onClick: () => true
  }

  return (
    <Link {...linkProps}>
      <Button {...buttonProps}/>
    </Link>
  )
}
